export default "__VITE_ASSET__PcfiIMlj__"